import React from "react";
import "./DirectorModal.css";

const DirectorModal = ({ director, closeModal }) => {
  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>
          &times;
        </button>
        <img src={director.image} alt={director.name} className="modal-image" />
        <h2>{director.name}</h2>
        <p>{director.achievements}</p>
      </div>
    </div>
  );
};

export default DirectorModal;
